var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import Vue from 'vue';
import Card from 'src/components/Card/Card.vue';
import convertToTree from 'src/utils/treeOperations/convertToTree';
import highlighter from 'src/utils/highlighter';
import setOptionValue from 'src/store/preferences/setOptionValue';
import getRecords from 'src/utils/entityOperations/getRecords';
import debounce from 'quasar/src/utils/debounce.js';;
import fromNumberToPercent from 'src/utils/displayFormatters/fromNumberToPercent';
import Form from 'src/components/Form/Form';
import match from 'src/utils/stringOperations/stringContains_inLowerCase';
import { omit } from 'lodash';
import arrayIsEmpty from 'src/utils/arrayOperations/arrayIsEmpty';
import fetchAllRecords from 'src/utils/entityOperations/fetchAllRecords';
import RefreshButton from 'src/components/ButtonsWithSemanticMeaning/RefreshButton.vue';
export default Vue.extend({
    components: { Card, Form, RefreshButton },
    data() {
        return {
            expandedKeysData: [],
            needle: '',
            showUpstreamBranchesOfFilteredNodes: true,
            showDownstreamBranchesOfFilteredNodes: true
        };
    },
    computed: {
        option_groups() {
            const records = getRecords('preferences.option_groups');
            const records2 = records.map(r => {
                const record = Object.assign({}, omit(r, ['id', 'parent_id']));
                record.id = 'OG-' + String(r.id);
                record.description = '';
                if (r.parent_id)
                    record.parent_id = 'OG-' + String(r.parent_id);
                const record2 = record;
                return record2;
            });
            return records2;
        },
        option_user_values() {
            const records = getRecords('preferences.option_user_values');
            const records2 = records.map(o => (Object.assign(Object.assign({}, omit(o, ['id', 'option_group_id', 'option_id', 'option_name', 'option_description', 'user_id'])), { id: String(o.option_id) || '', name: o.option_name, description: o.option_description, parent_id: 'OG-' + String(o.option_group_id), value: String(o.value), option_input_type: o.option_input_type, hide_from_ui_display: o.hide_from_ui_display })));
            return records2;
        },
        data() {
            const data = [...this.option_groups, ...this.option_user_values];
            return data;
        },
        treeToDisplay() {
            const { data } = this;
            if (arrayIsEmpty(data))
                return null;
            const treeData = convertToTree(data);
            if (!this.needle || '')
                return treeData;
            const needle = this.needle.toLowerCase();
            let res = [];
            const nodeMatch = (node) => {
                return (match(node === null || node === void 0 ? void 0 : node.name, needle)) || (match(node === null || node === void 0 ? void 0 : node.description, needle));
            };
            const childrenMatch = (node) => {
                var _a;
                if (nodeMatch(node))
                    return true;
                if (!node.children)
                    return false;
                if (node.children)
                    return Boolean((_a = node.children) === null || _a === void 0 ? void 0 : _a.find((c) => childrenMatch(c) || nodeMatch(c)));
                return false;
            };
            const ancestorMatch = (node) => {
                if (nodeMatch(node))
                    return true;
                if (node && node.parent_id)
                    return ancestorMatch(treeData === null || treeData === void 0 ? void 0 : treeData.find(r => r.id === node.parent_id));
                return false;
            };
            const filterChildren = (arr) => {
                let arr2 = arr.filter((node) => (match(node === null || node === void 0 ? void 0 : node.name, needle)) || (this.showUpstreamBranchesOfFilteredNodes && childrenMatch(node)) || (this.showDownstreamBranchesOfFilteredNodes && ancestorMatch(node)));
                arr2.forEach((a) => {
                    if (a.children) {
                        a.children = filterChildren(a.children);
                    }
                });
                return arr2;
            };
            res = filterChildren(treeData);
            return res;
        },
        needleIsEmpty() { return !this.needle || this.needle === ''; },
        needleIsNotEmpty() { return !this.needleIsEmpty; },
        expandedKeysComputed: {
            get() {
                var _a;
                if (this.needleIsNotEmpty)
                    return ((_a = this.treeToDisplay) === null || _a === void 0 ? void 0 : _a.map((r) => r.id)) || [];
                return this.expandedKeysData;
            },
            set(val) { if (val)
                this.expandedKeysData = val; }
        }
    },
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            this.handleChange = debounce(this.handleChange, 300);
            this.fetchData();
        });
    },
    methods: {
        fromNumberToPercent,
        highlighter,
        fetchData() {
            fetchAllRecords('preferences.option_user_values');
            fetchAllRecords('preferences.option_groups');
        },
        handleChange(id, e) {
            return __awaiter(this, void 0, void 0, function* () {
                yield setOptionValue(id, e);
                this.fetchData();
            });
        }
    }
});
